import {
    getTooltipLayerBtnCancelTmpl,
    getTooltipLayerBtnConfirmTmpl,
    getTooltipLayerTmpl,
} from "./templates/html.template";
import Popup from "./base/Popup";
import {
    isA11yCheckVersion,
    a11yAcessFocus
 } from "../functions/a11y.ui";


/**
 * PopupTooltip
 */

/**
#### HTML 구조 및 Data 속성 사용법  : tooltip - 팝업 타입 추가
** [http://172.20.160.28:9700/kbank_html_mmk/components/component_tooltip.html](http://172.20.160.28:9700/kbank_html_mmk/components/component_tooltip.html)
* ui-tooltip 처럼 작은 드롭다운형식이 아닌  툴팁 -> 반팝업 형식의 구조
*/
class PopupTooltip {
    popupTooltip;
    /**
     * @example 
     * frontUI.popupTooltip.open({
     *  button: '',  'element'
     *  title :'',   'string'
     *  list: '',    'string'  
     *  btnConfirm : {
     *      text : '',
     *      fn : fucntion(){}
     *    }
     * })
     * 
     * **예시**
     * $('[data-tooltip-popup] .btn-tooltip').off('click.tooltipPopup').on('click.tooltipPopup',function(){
        let _tooltipWrap = $(this).closest('[data-tooltip-popup]');
        let _title;
        if (_tooltipWrap.attr('data-group-title') == undefined) {
            _title = $(this).attr('title')
        } else {
            _title = _tooltipWrap.attr('data-group-title');
        }

        let _lists 
        if (_tooltipWrap.attr('data-group-num') == undefined) {
            _lists = _tooltipWrap.find('[tooltip-popup-desc]')[0].innerHTML;
        } else {
            _lists = $(`[tooltip-popup-desc="${_tooltipWrap.attr('data-group-num')}"]`)[0].innerHTML
        }

        frontUI.popupTooltip.open({
            button : $(this),
            title: _title,
            lists: _lists,
            btnConfirm: {
                text: '확인',
                fn: function(){console.log(2);}
            }
        })
    })
     */
    async open({button, title, subTitle, lists, btnCancel, btnConfirm,closeCallback }){
        this.popupTooltip = new PopupTooltipImpl();
        await this.popupTooltip.open({button, title, subTitle, lists, btnCancel, btnConfirm,closeCallback});
    }
    /**
    * @example 
    * frontUI.popupTooltip.close();
    */
    close(){
        this.popupTooltip && this.popupTooltip.close();
        this.$button?.focus();
    }
}
class PopupTooltipImpl extends Popup {
    defaults = {};
    constructor(el, options) {
        super('popupTooltip', el);

        this.init(el, options);
    }

    init(el, options) {
        this.popupInit(el, options);
    }

    render() {

    }

    openMotion() {
        if(isA11yCheckVersion()){
            const removeIdContent = document?.querySelector('#content-mmk');
            removeIdContent?.removeAttribute('aria-hidden');
        }
        /*! s: FETASK-a11y page 닫기버튼 추가 v.1.0.0 */
        const closeBtn = document.createElement('div');

        closeBtn?.setAttribute('role','button');
        closeBtn?.setAttribute('aria-hidden','false');
        closeBtn?.setAttribute('aria-label','팝업 닫기');

        closeBtn?.classList.add('close-btn');

        if($(this.$popup).find('.interest-group-top')[0]){
            $(this.$popup).find('.popup-content').parent().after(closeBtn);
        }else{
            if($(this.$popup).find('.popup-content').length){
                if($(this.$popup).find('.popup-content').parent()?.length){
                    $(this.$popup).find('.popup-content').parent().after(closeBtn);
                }else{
                    $(this.$popup).children().after(closeBtn);
                }
            }else if($(this.$popup).find('.title-group .title-field-popup').length){
                if($(this.$popup).find('.popup-content').parent()?.length){
                    $(this.$popup).find('.popup-content').parent().after(closeBtn);
                }else{
                    $(this.$popup).children().after(closeBtn);
                }
            }else if($(this.$popup).find('.popup-group').length){
                if($(this.$popup).find('.popup-section')?.length){
                    $(this.$popup).find('.popup-section').after(closeBtn);
                }else{
                    $(this.$popup).children().after(closeBtn);
                }
            }else{
                $(this.$popup).after(closeBtn);
            }
        }
        this.openCommonMotion({
            cancelMotion: false,
            callback: () => {
                if (this.$button.closest('[data-scroll-index]').attr('data-scroll-index') != undefined) {
                    this.titleIndex = this.$button.closest('[data-scroll-index]').attr('data-scroll-index');
                    this.$popup.find('.popup-content').scrollTop()
                    this.$popup.find('.popup-content').animate({scrollTop: this.$popup.find(`[scroll-idx="${this.titleIndex}"]`).position().top - 15}, 200);
                }
            }
        });
        

        $(closeBtn).off('click').on('click', (e) => {
            e.preventDefault();
            //$(this.$popup).data('ui').close();
            this.close();

            const uiWidget = document.querySelector('.ui-widget');
            const activeSlide = document.querySelector('.activeSlide');

            if(!uiWidget && !activeSlide) return;

            setTimeout(() => {
                const newArrPopup = [...new Set(Popup.arrPopup)];
                if(!newArrPopup?.length){
                    
                    //팝업 다 닫히고 위젯 포커스
                    setTimeout(() => {
                        const isCheckSelected = !Popup.a11yDetectSelectClose.isSelected && Popup.a11yDetectSelectClose.type === 'default';
                        //isCheckSelected && a11yAcessFocus(activeSlide, true);
                        if (isCheckSelected) {
                            this.$button.focus()
                        }
                    });
                    uiWidget?.setAttribute('aria-hidden', 'false');
                    activeSlide?.setAttribute('aria-hidden', 'false');
                }else{
                    uiWidget?.setAttribute('aria-hidden', 'true');
                    setTimeout(() => {
                        const isCheckSelected = !Popup.a11yDetectSelectClose.isSelected && Popup.a11yDetectSelectClose.type === 'default';
                        isCheckSelected && a11yAcessFocus(newArrPopup[newArrPopup?.length-1][0], true);
                        console.log(22222)
                    });
                }
            },700);
        });

        const closeBtns = this.$popup?.find('.close-btn');

        
        closeBtns && closeBtns?.each((idx,list) => {
            if(idx > 0){
                $(list).remove();
            }
        });
         /*! e: FETASK-a11y page 닫기버튼 추가 v.1.0.0 */
    }

    closeMotion(cb = () => {}) {
        this.closeCommonMotion({
            cancelMotion: false,
            callback: () => {
                this.detachEvents();

                cb();
            }
        });
    }
    async open({button, title, subTitle, lists, btnCancel, btnConfirm,closeCallback}) {
        this.btnCancel = btnCancel;
        this.btnCancelFn = btnCancel && btnCancel.fn;
        this.btnConfirm = btnConfirm;
        this.btnConfirmFn = btnConfirm && btnConfirm.fn;
        this.closeCallback = closeCallback;
        const titleHtml = title;
        const subTitleHtml = subTitle;
        const listsHtml = lists;
        const btnCancelHTML = btnCancel && getTooltipLayerBtnCancelTmpl(btnCancel.text);
        const btnConfirmHTML = btnConfirm && getTooltipLayerBtnConfirmTmpl(btnConfirm.text, btnConfirm.size);
        this.$popup = $(getTooltipLayerTmpl(titleHtml, subTitleHtml, listsHtml, btnCancelHTML, btnConfirmHTML));
        this.$popupContainer.append(this.$popup);
        this.$popup.attr('data-id', this.uiId);
        this.$button = button;
        this.attachEvents();
        this.openMotion();

        if (typeof this.$popup.data('ui') === 'undefined') {
            this.$popup.data('ui', this)
        }
    }

    close() {
        this.closeMotion(() => {
            this.detachEvents();
            this.$button?.focus();
        });
    }

    closeCallbackAction() {
        if (this.closeCallback && $.isFunction(this.closeCallback)) {
            this.closeCallback();
        } else {
            this.closeMotion();
        }
    }

    attachEvents() {
        this.$popup.on(`click${this.eventId}`, (e) => {  // CHPFMTASK-1750  툴팁팝업 close 모션 추가 
            if (this.btnCancel) {
                if (!this.closeCallback) {
                    this.close();
                }

                this.btnCancelFn();
            } else {
                if (this.$popup.attr('popup-show') == 'true') {  //  CHPFMTASK-801
                    if (e.target === e.currentTarget) {
                        this.closeCallbackAction();
                    }
                }
            }
        });    
        if (this.btnConfirm) {
            this.$popup.on(`click${this.eventId}`, '.ui-confirm', () => {
                if (!this.closeCallback) {
                    this.close();
                }

                this.btnConfirmFn();
            });
        }
    }

    detachEvents() {
        if (this.$popup) {
            this.$popup.off(this.eventId);
            this.$popup.remove();
            this.$popup = undefined;
        }
    }

    destroy() {
        this.detachEvents();
    }
}

export default PopupTooltip;
